module.exports = __webpack_public_path__ + "img/float_right.9df7547.png";